import { render, staticRenderFns } from "./OTFormSuccess.vue?vue&type=template&id=6f8a27b3&scoped=true&lang=pug"
import script from "./OTFormSuccess.vue?vue&type=script&lang=js"
export * from "./OTFormSuccess.vue?vue&type=script&lang=js"
import style0 from "./OTFormSuccess.vue?vue&type=style&index=0&id=6f8a27b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a27b3",
  null
  
)

export default component.exports